(function dropdownMenuPage() {
  const pageElement: HTMLElement | null = document.querySelector('.dropdown-menu-page');
  if (pageElement) {
    class DropdownMenuPage {
      public init() {
        const button = document.getElementById('dropdown-button');
        if (button) {
          button.addEventListener('click', () => {
            const dropDown = document.getElementById('dropdown') as HTMLSelectElement;
            const index = dropDown.selectedIndex;
            if (index > 0) {
              const url = new URL(dropDown.value, window.location.origin);
              url.hash = 's';
              window.location.assign(url);
            }
          });
        }
      }
    }

    const page = new DropdownMenuPage();
    page.init();
  }
})();
